///<reference path="../../../typings/api.d.ts" />

import API from "api";
import { HttpVerb } from "../../constants";

const panic = async data => {
  console.log(`selfExclude panic api called`);

  let url = "/api/user/panic";

  if (API)
    return await (API &&
      API.authenticatedRequest({
        method: HttpVerb.POST,
        url,
        data: data
      }));
};

export default {
  panic: panic
};
